import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Typography from '@mui/material/Typography';

import type {
  DataTableColumn,
  SortState,
} from '~/components/DataView/DataTable/utils/types';

type DataTableHeaderProps<TRow extends Record<string, unknown>> = {
  columns: Array<DataTableColumn<TRow>>;
  activeSort: SortState | null;
  onSort: (columnId: string) => void;
};

const DataTableHeader = <TRow extends Record<string, unknown>>({
  columns,
  activeSort,
  onSort,
}: DataTableHeaderProps<TRow>) => (
  <TableHead sx={{ border: 0 }}>
    <TableRow>
      {columns.map((column) => {
        const { id, align = 'left', width, minWidth, label, sortable } = column;
        const columnId = String(id);
        const isActiveSort = activeSort?.orderBy === columnId;
        const direction =
          isActiveSort && activeSort?.order ? activeSort.order : 'asc';

        return (
          <TableCell
            key={columnId}
            align={align}
            sortDirection={isActiveSort ? direction : undefined}
            sx={{
              width: width,
              minWidth: minWidth,
            }}
          >
            {sortable ? (
              <TableSortLabel
                active={isActiveSort}
                direction={direction}
                onClick={() => onSort(columnId)}
              >
                <Typography variant="h5">{label}</Typography>
              </TableSortLabel>
            ) : (
              <Typography variant="h5">{label}</Typography>
            )}
          </TableCell>
        );
      })}
    </TableRow>
  </TableHead>
);

export default DataTableHeader;
